import { createContext, useContext, useEffect, useMemo, useState } from 'react';

/*
 * ThemeContext - persists dark/light preference to localStorage. Defaults to
 * light on first visit (better for business audience + long-form content).
 * Toggles the `dark` class on <html>. The storage key is versioned so a
 * default change resets everyone once and their next toggle sticks again.
 */
const STORAGE_KEY = 'vidhura-theme-v3';
const DEFAULT_THEME = 'light';

const ThemeContext = createContext({ theme: DEFAULT_THEME, toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_THEME;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    return DEFAULT_THEME;
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const value = useMemo(
    () => ({ theme, toggle: () => setTheme((t) => (t === 'dark' ? 'light' : 'dark')) }),
    [theme]
  );
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
